import qs from 'qs';

import { client } from '../client';

export type ExportAuditTrailParams = {
  user_role?: string;
  user_name?: string;
  actor_name?: string;
  action_message?: string;
  search?: string;
  date_from?: string;
  date_to?: string;
  cursor?: string;
  case_id?: number;
  cases_only?: boolean;
  users_only?: boolean;
  include_case_creation?: boolean;
};

export const exportAuditTrailCsv = async (params?: ExportAuditTrailParams | string): Promise<Blob> => {
  let queryString = '';
  if (params && typeof params === 'object') {
    queryString = `?${qs.stringify(params, { skipNulls: true })}`;
  } else if (typeof params === 'string') {
    queryString = `?${params}`;
  }

  const response = await client.get<Blob>(`/admin/audit_trails/export${queryString}`, {
    responseType: 'blob',
  });

  return response.data;
};
